import { appConfig } from './../../app.config';
import { Injectable } from '@angular/core';
import { SharedService } from '../shared.service';
@Injectable()

export class ResetPasswordService {
  constructor(
    public sharedService: SharedService
  ) { }

  /**
   * API call for reset password
   * @param passwordData Updated password
   * @param userId User Password to update
   */
  resetUserPassword(passwordData: any, userId: any, isConnPasswordReset: any) {
    let resetPasswordUrl = '';
    if (isConnPasswordReset) {
      return this.resetConnectorPassword(passwordData, userId);
    } else if (userId) {
      resetPasswordUrl = appConfig.resetUserPassWord;
      resetPasswordUrl = resetPasswordUrl.replace(':userId', userId);
      return this.sharedService.putData(resetPasswordUrl, passwordData);
    } else {
      resetPasswordUrl = appConfig.resetPassWord;
      return this.sharedService.putData(resetPasswordUrl, passwordData);
    }
  }

  /**
   * API call for reset password
   * @param passwordData Updated password
   * @param userId User Password to update
   */
  resetConnectorPassword(passwordData, connectorId) {
    let resetConnPasswordUrl = appConfig.resetConnectorCredential;
    resetConnPasswordUrl = resetConnPasswordUrl.replace(':connectorId', connectorId);
    return this.sharedService.putData(resetConnPasswordUrl, passwordData);
  }

}


